import { Box, BoxProps } from "@mui/material";
import React from "react";

export const ListSearchContainer = (props: BoxProps) => (
    <Box display="flex" sx={{ margin: "0 1rem 1rem 1rem", width: "100%", maxWidth: "400px", ...props.sx }}>
        {props.children}
    </Box>
);
